import { CircularProgress } from '@healthinal/ui';

export const buttonLoadingIndicator = (
  <CircularProgress size="sm" sx={{ '--CircularProgress-size': '16px', '--CircularProgress-thickness': '2px' }} />
);
